import { useCallback, useState, useRef } from 'react'

import LockedIcon from '@carbon/icons-react/lib/Locked'
import Overflow from '@carbon/icons-react/lib/OverflowMenuVertical'
import SettingsIcon from '@carbon/icons-react/lib/Settings'
import useEventListener from 'lib/hooks/useEventListener'
import SlideDown from 'lib/ui/Animations/SlideDown'
import Button from 'lib/ui/Button'
import Icon from 'lib/ui/Icon'
import { useRouter } from 'next/router'
import { ColorProps } from 'utils/types'
import { origin } from 'utils/window'

import * as css from './styles'
import { User } from '../DashboardLayout.types'

interface IUserMenu {
  brandColor: ColorProps
  user: User
}

const UserMenu = ({ brandColor, user }: IUserMenu) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const { push } = useRouter()

  const menuRef = useRef(null)

  const handleClick = useCallback(event => {
    const focusingMenu = menuRef.current?.contains(event.target)
    if (!focusingMenu) {
      setMenuOpen(false)
    }
  }, [])

  useEventListener('click', handleClick)

  const handleLogout = () => {
    push('/logout')
  }

  return (
    <div css={css.userStyles} ref={menuRef}>
      <button
        css={css.userMenuBtn(brandColor)}
        data-testid='user-menu-btn'
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <div css={css.menuWrap}>
          <SlideDown open={menuOpen} overflow='hidden'>
            <div css={css.menu(brandColor)}>
              <Button
                id='preferences-btn'
                buttonSize='sm'
                variant='text'
                href='/dashboard/preferences'
              >
                <SettingsIcon size={16} /> Preferences
              </Button>
              <Button
                id='security-btn'
                buttonSize='sm'
                variant='text'
                styles={{ borderRadius: 0 }}
                href={`${process.env.NEXT_PUBLIC_AUTH_DOMAIN}/settings/password?backDomain=${origin}`}
              >
                <LockedIcon size={16} /> Security settings
              </Button>
              <Button
                id='logout-btn'
                buttonSize='sm'
                variant='text'
                onClick={handleLogout}
              >
                <Icon
                  name='logout'
                  width={1.6}
                  height={1.6}
                  viewBox='0 0 16 16'
                  color='primary'
                />
                Log out
              </Button>
            </div>
          </SlideDown>
        </div>

        <div css={css.userMenu(brandColor)}>
          <Icon
            name='avatar'
            color={!brandColor ? 'grey10' : 'grey30'}
            width={2.5}
            height={2.5}
            viewBox='0 0 25 25'
          />
          <div css={css.small(brandColor)}>
            <span data-testid='user-menu-firstName'>{user?.firstName}</span>{' '}
            <span data-testid='user-menu-lastName'>{user?.lastName}</span>
            <div>{user?.email}</div>
          </div>
          <Overflow size={24} />
        </div>
      </button>
    </div>
  )
}

export default UserMenu
